import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { EmailDraftDataDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  data: EmailDraftDataDto;
  emailId: string;
  threadId: string;
  userId: string;
};

type Return = {
  isUpdatingEmailDraft: boolean;
  updateEmailDraft: (req: Req) => Promise<void>;
};

export const useUpdateEmailDraft = (): Return => {
  const { emailUpdateApi } = useEmailApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      console.trace('updateDraftEmail');
      await emailUpdateApi.updateDraftEmail(req.userId, req.emailId, req.data);
    },
    mutationKey: [QueryKeyEnum.EMAILS.DRAFT.UPDATE],
    onSuccess: async (_, req) => {
      await queryClient.refetchQueries(
        { queryKey: [QueryKeyEnum.EMAILS.THREAD, req.threadId] },
        { throwOnError: false },
      );
    },
  });

  return {
    isUpdatingEmailDraft: isPending,
    updateEmailDraft: mutateAsync,
  };
};
